/* eslint-disable max-lines */
export const messages = {
    brandName: 'Neuronio',
    date: 'Date',
    creationDate: 'File creation date',
    week: 'Week',
    day: 'Day',
    patientList: 'Patient List',
    notExistPatients: 'patient information has not been recorded yet',
    reports: 'Reports',
    mainSearch: 'Search name, last name or national code',
    newPatient: 'New Patient',
    appointments: 'Appointment',
    waitingRoom: 'Waiting Room',
    inside: 'Inside',
    visited: 'Visited',
    noResult: 'Nothing Found',
    addNewPatient: 'Add New Patient',
    logout: 'logout',
    name: 'name',
    and: 'and',
    lastname: 'lastname',
    deleteAppointment: 'delete',
    moveAppointmentTo: 'move appointment to',
    movePatientTo: 'move patient to list of',
    NID: 'National Id',
    exNID: 'Citizenship Id',
    birthDate: 'Birth Date',
    gender: 'Sex',
    male: 'Male',
    female: 'Female',
    nonBinary: 'other',
    maritalStatus: 'Marital Status',
    single: 'Single',
    married: 'Married',
    divorced: 'Divorced',
    widowed: 'Widowed',
    firstName: 'First Name',
    lastName: 'Last Name',
    fullName: 'Full Name',
    search: 'Search',
    birthplace: 'Birthplace',
    phoneNo: 'Phone No',
    phoneNo2: '2nd Phone No',
    nationality: 'Nationality',
    fatherName: "Father's Name",
    city: 'City',
    address: 'Address',
    submitPatient: 'Submit',
    edit: 'edit',
    cancel: 'Cancel',
    optional: 'Optional',
    validations: {
        incorrectName: 'Enter name correctly',
        incorrectLastName: 'Enter lastname correctly',
        exceedMaxLength: 'Character length exceeds valid length',
        required: 'This field is required',
        incorrectValue: 'Enter field correctly',
        emptyPrescription: 'Please fill the prescription',
        incompletePrescription: 'Please fill the prescription completely',
        phoneNumber: 'Phone number must be at least 11 numbers',
        passwordLength: 'Password must be at least 8 numbers'
    },
    sidebar: {
        visit: 'Visit (Medical Hx)',
        laboratory: 'Laboratory',
        newLaboratory: 'New test',
        radiology: 'Radiology',
        medication: 'Medication',
        appointment: 'New Appointment',
        patientFile: "Patient's file",
        forms: 'Forms',
        newForm: 'New Form',
        form: 'Form',
        test: 'Test'
    },
    close: 'Close',
    existFromPatient: 'Exit from patient file',
    download: 'Download',
    time: 'Time',
    nationalOrCitizenId: 'National / Citizenship Code',
    age: 'Age',
    downloadReports: 'Download Report',
    downloadReportInPatients: 'Download',
    admission: 'Admission',
    addNewAppointment: 'New Appointment',
    no: 'No',
    yes: 'Yes',
    hour: 'Hour',
    reasonOfReferral: 'Reason of referral',
    status: 'Status',
    clinic: 'Clinic',
    appointment: 'Appointment',
    appointmentStatus: {
        visited: 'Visited',
        entered: 'Entered',
        admitted: 'Admitted',
        appointed: 'Appointed'
    },
    alerts: {
        deleteAppointment: 'Are you sure about deleting this appointment?',
        askDeleteAppointment: 'Are you sure about deleting appointment of ',
        areYouSure: 'Are you sure',
        at: 'at',
        deletePrescription: 'Are you sure about deleting prescription of doctor',
        success: 'Operation has done successfully',
        errorLabImageUpload: 'Some images is not uploaded',
        error: 'Face some problem',
        deleteImageTitle: 'Are you sure about deleting this image?',
        deleteImageHint: 'Deleted image would not be recovered',
        deleteRadiology: 'Are you sure about deleting this radiology report?',
        deleteRadiologyHint: 'Deleted Radiology report would not be recovered',
        deleteFormEntry: 'Are you sure about deleting form of ',
        changeClinic:
            'Will the list of selected patients be deleted when the clinic is changed, Are you sure?',
        deleteFormEntryNew:
            "if you delete the form you can't recover it, Are you sure about deleting this from?",
        deleteLaboratoryTest:
            "if you delete the Test you can't recover it, Are you sure about deleting this Test?",
        unBlockFormRoute:
            'Changes made to the form are not currently saved. Do you want to return the form to save?',
        deletePatient: 'Are you sure you want to delete this patient?',
        deleteChanges: 'Delete changes and continue',
        returnToForm: 'Return to Form',
        warningNumberOfPatients:
            'The number of open patient cases is more than 5. A patient file must be closed to open a new file.',
        ok: 'ok',
        validationPatientForm: 'please Enter the desired fields carefully',
        clinicAccess1: 'There is no clinic with ID',
        clinicAccess2: 'on your clinic list',
        deleteUser:
            'By deleting the user, the user is completely deleted from this collection. Are you sure you want to do this? ',
        deleteExport:
            'Deleting this report will not recover the report information, are you sure you want to delete this report?'
    },
    synchronousAdmission: 'Synchronous Admission',
    reserveAppointment: 'Submit Appointment',
    editAppointment: 'Edit Appointment',
    editAppointmentSynchAdmit: 'Edit Appointment and Admission submit',
    submitAppointmentSynchAdmit: 'Appointment and Admission submit',
    insurance: 'Insurance',
    insuranceNo: 'Insurance No',
    arrivalMode: 'Arrival Mode',
    patientCompanionName: 'Companion Name',
    patientCompanionLastName: 'Companion Last Name',
    companionRelationship: 'Companion Relationship',
    prev: 'previous',
    submitAdmission: 'Submit Admission',
    newPrescription: 'Add New Prescription',
    // lab
    newLabData: 'New lab data',
    editLabData: 'Edit lab data',
    save: 'Save',
    noLabImageFound: 'No Laboratory Image was uploaded',
    noLabDataFound: 'No Laboratory Data Found',
    addLabImageHint: 'Click to add Lab images',
    addImage: 'Add Image',
    saveLab: 'Save lab data',
    // radiology
    noReportSelected: 'No report has been selected',
    addNewReport: 'Add new report',
    noReport: 'No report has been recorded',
    newRadiology: 'New Radiology Report',
    editRadiology: 'Edit Radiology Report',
    modality: 'Modality',
    location: 'Location',
    requester: 'Requester',
    hospital: 'Hospital',
    submit: 'Submit',
    saveChanges: 'Save Changes',
    delete: 'Delete',
    noLocationFound: 'no result',
    // Form
    selectFormType: 'Select type of form',
    newForm: 'New Form',
    noFormSubmitted: 'No form has been submitted yet',
    postActionAlert: {
        admissionEditedSuccess: 'Admission was successfully edited',
        admissionSubmitSuccess: 'Admission was successfully submitted',
        appointmentStatus: 'Status was changed successfully',
        prescriptionAdded: 'Prescription was successfully added',
        prescriptionEdited: 'Prescription successfully edited',
        prescriptionDeleted: 'Prescription successfully deleted',
        formSubmitted: 'Form Entry was successfully submitted',
        formEdited: 'Form Entry was successfully edited',
        formDeleted: 'Form Entry was successfully deleted',
        patientSubmitted: 'Patient was successfully submitted',
        patientEdited: 'Patient was  successfully edited',
        patientDeleted: 'Patient was successfully deleted',
        reportSubmitted: 'Report was successfully submitted',
        reportEdited: 'Report was successfully edited',
        reportDeleted: 'Report was successfully deleted',
        imageDeleted: 'Image was successfully deleted',
        limitAccess: 'You do not have access to this clinic',
        refreshAppointmentList: 'Updating appointment states',
        appointmentSubmitted: 'Appointment was successfully submitted',
        appointmentDeleted: 'Appointment successfully deleted',
        appointmentEdited: 'Appointment successfully edited'
    },
    // forms setting
    formsSetting: 'Forms Setting',
    addClinic: 'Add Clinic',
    formName: 'Form Name',
    clinicsOfForm: 'Assigned Clinics',
    editForm: 'Edit Form',
    deleteForm: 'Remove Form',
    formTitle: 'Form Title ',
    formDescription: 'Form Description',
    formUID: 'Form Unique Identifier',
    complementaryFormInfo: 'Complementary Information',
    formUIDTip: 'If you mind adding specific unique identifier to the form',
    selectClinics: 'Select clinics',
    formSubject: 'Form Subject',
    sideRightCalenderTooltip: 'Appointments',
    changePassword: 'Change password',
    exist: 'Exist',
    listOfPatients: 'List of patients',

    setting: 'Setting',
    profile: 'Profile',
    logOutFromProfile: 'Log out from profile',
    dr: 'Dr.',
    forms: 'Forms',
    comparison: 'Comparison',
    back: 'Back',
    selectForm: 'Select the form first',
    new: 'New',
    registerPrescription: 'Register Prescription ',
    images: 'Images',
    nextStep: 'Next step',
    createReport: 'Create Report',
    options: 'Options',
    deleteFormDialog: {
        text1: 'By doing this,the Form',
        text2: 'initial patient history',
        text: 'and all related or Dependent information,',
        text4: 'will be',
        text5: 'deleted.',
        text6: 'this information after deletion',
        text7: ' will not be recoverable.',
        text8: 'are you sure you want to delete this form permanently?',
        message: 'if you are sure, please write the following phrase in the box below.'
    },
    notExistForm: 'No form has been registered for this patient yet',
    loadingMessage: 'Loading',
    reCreateReport: 'Re-create report',
    warningFormReport: 'Reports created from forms will be deleted after 7 days',
    createdReportDate: 'Created Report Date',
    editFormStructure: 'Edit Form Structure',
    editFormTitle: 'Edit Form Title',
    editFormInfo: 'Edit Form Info',
    desiredClinic: 'The desired clinic',
    changeClinicMessage: 'By changing the clinic, the patients file of your choice will be closes.',
    selectClinicHeader: 'Select Clinic',
    selectClinicMessage: 'First, select your desired clinic from the menu below.',
    login: {
        formHeader: 'Login',
        formMessage: 'Enter your phone number and password',
        username: 'Phone number',
        password: ' Password',
        buttonText: 'Log in',
        usernamePlaceholder: 'Enter your user name',
        passwordPlaceholder: 'Enter your password',
        required: 'This field is required.',
        rememberMe: 'Remember me',
        forgetPassword: 'Forget Password?',
        welcomeMessage: 'Welcome to Synapps'
    },
    deletePatientFile: 'Delete patient file',
    closeMenu: 'Close menu',
    openMenu: 'open menu',
    closePatient: 'Close Patient',
    newField: 'New field',
    fieldName: 'Field Name',
    fieldValue: 'Field Value',
    from: 'From',
    to: 'To',
    dateOfCreationForm: 'Date of creation of form',
    nameAndLastName: 'Name And LastName of Patient',
    validationSearch: {
        maxOfWord: 'Maximum letters are 30 characters.',
        maxOfSelect: 'The Maximum number of items is 10 ',
        maxAndMinValue: "the value of the 'from' field cannot be greater than value of 'to' field."
    },
    notAccessClinic: "you don't have access to any clinic.",
    errorOccurred: 'An error has occurred',
    editedBy: 'Edited by',
    inDate: 'in',
    id: 'id',
    statistics: 'Statistics',
    newForms: 'New Forms',
    newPatients: 'New Patients',
    lastWeek: 'Last Week',
    formType: 'Form Type',
    total: 'Total',
    patients: 'Patients',
    noResultFound: 'No Result Found',
    formUpdatingDate: 'Form updating Date',
    permissionsTitle: {
        write_demographic: 'Write demographic',
        read_clinical: 'Read clinical',
        write_clinical: 'Write clinical',
        aggregate_data: 'Reporting',
        manage_form: 'Manage form',
        manage_user: 'Manage user',
        manage_clinic: 'Manage clinics'
    },
    permissionsDesc: {
        write_demographic: 'The user can edit the patient file information and his appointment.',
        read_clinical: `The user can view the patient's clinical information including forms, laboratory, medication and radiology.`,
        write_clinical:
            'The user can add or edit patient clinical information including forms, laboratory, medication and radiology.',
        aggregate_data:
            'The user can report the information available in their clinics or use the advanced search.',
        manage_form:
            'The user can edit or delete the structure and title of the forms related to his clinic.',
        manage_user: 'The user can add or subtract other users to their clinics.',
        manage_clinic: 'The user can manage or add existing clinics.'
    },
    user: 'User',
    clinics: 'Clinics',
    polyclinic: 'Polyclinic',
    editInfo: 'Edit Info',
    deleteUser: 'Delete User',
    newUser: 'New User',
    editUser: 'Edit User Info',
    permission: 'Permissions',
    delegatePerm: 'The permissions that the user can grant to other users',
    addUser: 'Add User',
    phoneNumber: 'Phone Number',
    userRegistration: 'User Registration',
    owner: 'Owner',
    you: 'You',
    relatedClinics: 'Related Clinics',
    notFoundUser: 'There are no users in this clinic',
    noClinicFound: 'There is no clinic',
    developing: 'Developing...',
    notFoundListOfForm:
        'No form created. Before creating a form, you must create it in the settings section',
    print: 'Print',
    medicalCenter: 'Medical center',
    patientInfo: 'Patient Info',
    summonPatient: 'Patient admission to the clinic',
    summonPatientDesc:
        'The patient has not been admitted to this clinic, you can add the patient to the current clinic by clicking on this option and view the patient file.',
    viewPatientFile: 'View patient file',
    attendingClinics: 'Attending Clinics',
    attendingClinicsDesc:
        'The patient is exist in this clinic, you can view the patient file by clicking on this option',
    patient: 'Patient',
    alertMessage: 'This section is still developing, it may not work properly.',
    createdBy: 'Created By',
    title: 'Title',
    key: 'Key',
    viewHeaderWith: 'View Header With',
    viewMultipleWith: 'View multiple options with',
    identifier: 'Id',
    flatSelect: 'choice and others separated into two columns',
    clinicName: 'Clinic Name',
    newClinic: 'New Clinic',
    editClinic: 'Edit Clinic',
    submitClinic: 'Submit Clinic',
    listOfReports: 'List of Reports',
    noReportFound: 'No report found',
    baseInfo: 'Base information',
    username: 'username',
    forgetPassword: 'change Password',
    prevPassword: 'previous password',
    newPassword: 'new password',
    confirmPassword: 'confirm new password',
    notSamePassword: 'Passwords are not the same',
    notFound1: 'you currently do not have access to this page.',
    notFound2: 'to enter this page, the relevant access must be given to you by the clinic admin.',
    formInfo: 'Form info',
    formExportCreatedBy: 'Report created by',
    allClinics: 'All Clinics',
    exportFromClinics: 'Export From Clinic:',
    unitNumber: 'Unit Number',
    ward: 'Ward',
    room: 'Room',
    bed: 'Bed',
    attendingPhysician: 'Attending Physician',
    admissionDate: 'Date Of Admission',
    occupation: 'Occupation',
    dischargDate: 'Date of Discharg'
};
